<template>
  <div class="custom-textarea">
    <v-subheader
      class="pa-0"
      v-if="label"
    >
      <label
        for="textarea"
        class="neutral-cold-051--text text-body-3"
      >{{ label }}</label>
    </v-subheader>
    <v-textarea
      id="textarea"
      v-bind="{ ...$attrs, ...commonAttrs }"
      v-on="$listeners"
    >
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        #[scopedSlotName]="slotData"
      >
        <slot
          :name="scopedSlotName"
          v-bind="slotData"
        />
      </template>
      <template
        v-for="(_, slotName) in $slots"
        #[slotName]
      >
        <slot :name="slotName" />
      </template>
      <template slot="append-outer">
        <v-icon size="16">
          $vuetify.icons.inputErrorIcon
        </v-icon>
      </template>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    commonAttrs() {
      return {
        label: '',
        persistentHint: true,
        outlined: true,
        dense: true,
        // hideDetails: 'autoæ,
        class: {
          'mt-1': this.$props.label
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.custom-textarea {
  width: 100%;
  .v-text-field__slot {
    textarea {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      &::placeholder {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: $neutral-042;
      }
    }
  }

  .v-textarea {
    .v-input__slot {
      min-height: auto !important;
    }
    // textarea min height
    &.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea {
      margin-top: 0;
    }

    // Default Style
    textarea {
      padding-top: 7px;
      padding-bottom: 7px;
      min-height: 24px;
    }
    fieldset {
      background: $neutral-cold-058;
      border: 1px solid $neutral-cold-053;
      transition: all 0.3s ease-in-out;
    }

    // Fill Style
    &.v-input--is-label-active:not(.v-input--is-focused, .v-input--is-disabled, .v-input--is-readonly) fieldset {
      border-color: $neutral-cold-052;
    }

    // Hover Style
    &:hover fieldset {
      border-color: $neutral-cold-052;
    }

    // Focus Style
    &.v-input--is-focused fieldset{
      background: $neutral-047;
      border-color: $primary-001;
      box-shadow: 0px 0px 0px 2px rgba(64, 143, 255, 0.25);
    }

    // Disabled Style
    &.v-input--is-disabled {
      fieldset{
        background: $neutral-cold-057;
        border-color: $neutral-cold-055;
      }
      ::-webkit-resizer{
        display: none;
      }
    }

    // Readonly Style
    &.v-input--is-readonly {
      textarea {
        color: $neutral-042;
        &::placeholder {
          color: $neutral-042;
        }
      }
      fieldset{
        background: $neutral-cold-057;
        border-color: $neutral-cold-055;
        box-shadow: none;

      }
    }

    // Error Style
    &.error--text fieldset {
      background: $neutral-047;
      border-color: $danger-021;
      box-shadow: 0px 0px 0px 2px rgba($danger-021, 0.25);

    }
    .v-messages{
      margin-left: 22px;
    }
    .v-input__append-outer{
      position: absolute;
      bottom: -3px;
      left: 0;
      margin-left: 0;
      display: none;
    }
    &.error--text .v-input__append-outer{
      display: inline-flex;
    }

    // text counter
    .v-counter {
      position: absolute;
      top: -16px;
      right: 0;
    }
  }

}

</style>
